export enum YouTubeVideoId {
  ImprovedReporting = 'z-FQLxoMu1Y',
  AssetDetails = 'ZaCRwz-dvgk',
  FleetHealth = 'IBV4YOGw0nw',
  FleetPerformance = 'fpAc-3GkMEs',
}
